import { maskCurrencyInput } from '@/lib/mask'

import { areaFieldsMapper } from '@/utils/transformers/filters/areas'

export default {
  name: 'oz-areas',

  props: {
    min: { type: [String, Number], default: '' },
    max: { type: [String, Number], default: '' },
    totalArea: { type: Boolean },
  },

  data () {
    return {
      label: 'Área do imóvel',
      usableAreasMin: '',
      usableAreasMax: '',
      invalidInputMessage: 'Área máxima deve ser maior que área mínima',
      isInvalid: false,
    }
  },

  created () {
    this.usableAreasMin = this.min ? this.min.toString() : ''
    this.usableAreasMax = this.max ? this.max.toString() : ''
  },

  watch: {
    min () {
      this.usableAreasMin = this.min ? this.min.toString() : ''
    },
    max () {
      this.usableAreasMax = this.max ? this.max.toString() : ''
    },
  },

  computed: {
    placeholderMin () {
      return '0 m²'
    },

    placeholderMax () {
      return '1 tri m²'
    },

    maskedUsableAreasMin: maskCurrencyInput('usableAreasMin'),

    maskedUsableAreasMax: maskCurrencyInput('usableAreasMax'),
  },

  methods: {
    onInputUsableAreasMin (inputedValue) {
      this.isInvalid = false
      inputedValue = this.removeMask(inputedValue)
      this.usableAreasMin = inputedValue.toString()
    },

    onInputUsableAreasMax (inputedValue) {
      this.isInvalid = false
      inputedValue = this.removeMask(inputedValue)
      this.usableAreasMax = inputedValue.toString()
    },

    onBlur () {
      const { usableAreasMin, usableAreasMax } = this

      if (usableAreasMin && usableAreasMax
        && (parseInt(usableAreasMin, 10) > parseInt(usableAreasMax, 10))) {
        this.isInvalid = true
        return
      }

      this.updateFilter()
    },

    removeMask (valueMasked) {
      return valueMasked.split('.').join('')
    },

    updateFilter () {
      const { usableAreasMin, usableAreasMax } = this

      this.$emit('filters:update', areaFieldsMapper(this.totalArea, {
        min: usableAreasMin,
        max: usableAreasMax,
      }))
    },
  },
}
